<template>
    <div>
      <!-- Modal -->
      <v-dialog v-model="modelValue" max-width="400" persistent>
        <v-card>
          <v-card-title class="headline">Próximo passo</v-card-title>
          <v-card-text>
            Você está no passo {{ nextStep }} e vai levar em media {{ nextStepValue }} dias úteis para concluirmos nossa análise 
            , para que assim consiga seguir para os proximos passos.
            <br />
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="success" text @click="closeModal">
              Ok
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </template>
  
  <script>
  import DatesService from "@/services/firebase/Dates/DatesService";
  
  export default {
    name: "AverageNextStep",
    props: {
      nextStep: {
        type: String,
        required: true
      },
      modelValue: {
        type: Boolean,
        required: true
      }
    },
    data: () => ({
        datesAverage: [],
    }),
    computed: {
      nextStepValue() {
        const step = this.datesAverage.find(option => 
          option.text.toLowerCase() === this.nextStep.toLowerCase()
        );
        return step ? step.value : 'Não definido';
      }
    },
    methods: {
        async loadAverageDates() {
            try {
                this.showAverageNextStep = true
                this.datesAverage = await DatesService.getAverageDates();
            } catch (error) {
                console.error('Erro ao carregar datas médias:', error);
            }
        },
        closeModal() {
          this.$emit('update:modelValue', false);
          this.$emit('closed');
        }
    },
    async mounted() {
        await this.loadAverageDates();
    }
  };
  </script>
  
  <style scoped>

  </style>
  